export default __webpack_public_path__ + "static/media/UserInterests-reduced.c94dd265.jpg";